import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormControl} from '@angular/forms';

/** @title Datepicker selected value */
@Component({
  selector: 'app-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css'],
})
export class DatepickerComponent implements OnInit {
  @Input() value: Date | null;
  @Output() valueChange = new EventEmitter<Date | null>();  
  placeholder: string = 'Select Wanted Date';
  selectedDate = new FormControl(new Date());
  minDate: Date;
  maxDate: Date;

  ngOnInit(): void {
    let currentYear = new Date().getFullYear();
    let currentMonth = new Date().getMonth();
    this.minDate = new Date();
    this.maxDate = new Date(currentYear, currentMonth + 1, 31);
  }

  onDateSelected(date: Date | null): void{
    this.value = date;
    this.valueChange.emit(this.value);

    this.placeholder = date ? '' : 'Select Wanted Date';
  }

  formatDate(date: Date): string {
    // Format the date as needed (e.g., dd/MM/yyyy)
    // Implement your own date formatting logic here
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }

  filterDate = (date: Date | null): boolean => {
    if (!date) {
      return false;
    }

    const currentDate = new Date();
    return date >= currentDate && date.getDay() !== 0 && date.getDay() !== 6;
  };
}


// WEBPACK FOOTER //
// ./src/app/datepicker/datepicker.component.ts